import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
}), 'ViewCompact');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewCompact.js
// module id = 7090
// module chunks = 2